import { dealFormConfig } from '@/utils/preObjectManage/utils'
import { fieldTypeConfig } from '@/enums/preObjectManage'
import { isNullOrUnDef, isNullOrUndefOrEmpty } from '@/utils/is'
import { ref } from 'vue'
import { cloneDeep, GenNonDuplicateID } from '@/utils/tools'
import {
  titlelist,
  pictureArr,
  precisionsObj,
  unitObj,
  trimKeys
} from '@/views/erp/enums'

interface ListItem {
  affiliationType: string
  subField: 0 | 1
  subs: Recordable[]
}

export interface FormValue {
  baseExtendDO: Recordable // 基本信息
  baseExtendDTO: Recordable // 基本信息
  retailIntoInfoDO: Recordable // 审批信息
  infoDTO: Recordable // 审批信息
  contractList: Recordable[] // 合同列表信息
  retailShopProductVO: Recordable // 产品信息
  relateExtendDTOList: Recordable[] // 子表信息
  phone: string // 解密手机号
}

export interface DefaultValue {
  baseExtendDTO: Recordable // 基本信息
  infoDTO: Recordable // 审批信息产品信息
  relateExtendDTOList: Recordable[] // 子表信息
}
import EventEmitter from '@/utils/event'

const visibleEmitter = new EventEmitter()
export function useIncomeDetail({
  defaultValues,
  permissions,
  showAll
}: {
  defaultValues: DefaultValue
  permissions: Recordable
  showAll: boolean
}) {
  // 要显示的布局的数据容器
  const positionsList = ref<Recordable[]>([])
  // 显隐规则容器
  const visibleList = ref<{ field: string; rule: any[] }[]>([])

  const formDataField = ref<Recordable>({}) // 主表
  const originFormData = ref<Recordable>({}) // 主表初始值
  const formDataList = ref<Recordable>({}) // 子表

  // 基础信息
  const baseExtendDO = ref<Recordable>({})
  // 审批信息
  const retailIntoInfoDO = ref<Recordable>({})
  // 产品详情
  const productDetails = ref<Recordable>({})
  // 处理数据格式
  async function formatFieldConfig(
    list: ListItem[],
    allValue: FormValue,
    subTableApi: Fn,
    id: string
  ) {
    // list => [{'affiliationType': '联系人', '基本信息', '共同贷款人','股东信息'}, subs: [], subField: 0主表,1子表]
    positionsList.value = []

    retailIntoInfoDO.value = Object.assign(
      allValue?.retailIntoInfoDO || allValue?.infoDTO || {},
      {
        decryptPhone: allValue?.phone
      }
    )
    if (defaultValues?.infoDTO) {
      for (const key in unref(retailIntoInfoDO)) {
        if (defaultValues.infoDTO?.[key]) {
          if (key !== 'customerId') {
            // 客户id已接口给的为准 其余的已缓存为准
            retailIntoInfoDO.value[key] = defaultValues.infoDTO?.[key]
          }
        }
      }
    }
    baseExtendDO.value = allValue?.baseExtendDO || allValue?.baseExtendDTO
    console.log({ ...baseExtendDO.value }, 'xixixix')
    if (defaultValues?.baseExtendDTO) {
      for (const key in unref(baseExtendDO)) {
        if (defaultValues.baseExtendDTO?.[key]) {
          baseExtendDO.value[key] = defaultValues.baseExtendDTO?.[key]
        }
      }
    }
    console.log({ ...baseExtendDO.value }, 'xixixix')
    const relateExtendDTOList =
      defaultValues.relateExtendDTOList || allValue.relateExtendDTOList || []
    let productInfo: Recordable = allValue.retailShopProductVO
    if (retailIntoInfoDO.value?.productJson) {
      try {
        productInfo = JSON.parse(retailIntoInfoDO.value.productJson)
      } catch (e) {
        console.error(e)
      }
    }
    productDetails.value = {
      ...productInfo,
      id: productInfo.id || allValue.retailShopProductVO.id
    }
    // 这一步是为了处理审批时删掉了数据，回显还是有数据的bug
    for (const key in allValue.retailIntoInfoDO) {
      if (!isNullOrUndefOrEmpty(allValue.retailIntoInfoDO[key])) {
        // customerId优先取接口返回的 其余的默认取缓存的
        if (key !== 'customerId') {
          unref(retailIntoInfoDO)[key] =
            defaultValues?.infoDTO?.[key] || allValue.retailIntoInfoDO?.[key]
        }
      }
    }
    for (let i = 0; i < list.length; i++) {
      const module: Recordable = list[i]
      module.tID = GenNonDuplicateID(3)
      // 根据affiliationType获取对应的subType
      titlelist.forEach(data => {
        if (module.affiliationType === data.label) {
          module.subType = data.value
        }
      })
      // 只处理子表的显示和隐藏
      if (module.subField === 1) {
        module.show = true
        module.visibleEmitter = visibleEmitter
        // 默认值回填
        let subTableData = []
        if (relateExtendDTOList?.length) {
          subTableData = relateExtendDTOList.filter(
            item => +item.subType === module.subType
          )
        } else {
          subTableData = await subTableApi({ id: id, type: module.subType })
        }
        // 子表数据写入
        module.tableData = subTableData
      }

      module.subs = module.subs.map((item: Recordable) => {
        // 判断该字段有没有现有规则
        if (item.showHideRule) {
          visibleList.value.push({
            field: item.field,
            rule: JSON.parse(item.showHideRule)
          })
        }

        // 主表
        if (module.subField === 0 && item.field) {
          // 传进来的值
          const defaultValue = defaultValues?.baseExtendDTO?.[item.field] || ''
          // 原值
          let value =
            item.type === fieldTypeConfig.picture ||
            item.type === fieldTypeConfig.enclosure
              ? []
              : ''
          const baseExtendDTO =
            allValue?.baseExtendDO || allValue?.baseExtendDTO
          if (baseExtendDTO) {
            Object.keys(baseExtendDTO).forEach(key => {
              if (key === item.field) {
                // 赋值
                value = baseExtendDTO[key]
              }
            })
            formDataField.value.id = baseExtendDTO.id
          }
          formDataField.value[item.field] = defaultValue || value
        }
        //  子表的回显值
        if (module.subField === 1 && item.field) {
          formDataList.value[item.field] =
            item.type === fieldTypeConfig.picture ||
            item.type === fieldTypeConfig.enclosure
              ? '[]'
              : ''
        }

        const strategyFn =
          dealFormConfig[item.type] ||
          dealFormConfig[fieldTypeConfig.singleLineText] // 默认值为单行文本
        const config = { ...item }
        //  下拉option： columnDataList
        if (item.type === fieldTypeConfig.select)
          config.columnDataList = JSON.parse(item.options)
        //  上传 columnOperateList
        if (
          item.type === fieldTypeConfig.picture ||
          item.type === fieldTypeConfig.enclosure
        ) {
          if (pictureArr.includes(item.field)) {
            config.columnOperateList = [
              { code: 'COLUMN:PICTURE_ONE', value: true }
            ]
          }
        }

        // 要改
        if (item.type === fieldTypeConfig.address) {
          config.columnOperateList = [
            { code: 'COLUMN:PICTURE_ONE', value: true }
          ]
          config.labelWidth = 400
        }

        if (isNullOrUnDef(config.precisions)) {
          // 根据不同的字段确确定精度,单位
          config.precisions = getPrecisionsByName(item)
          config.unit = getUnitByName(item)
        }
        const renderConfig = strategyFn({ ...config }, { tableColumnType: 10 })

        if (item.type === fieldTypeConfig.select) {
          renderConfig.visibleEmitter = visibleEmitter
        }
        // 图片用另一个组件
        if (item.type === fieldTypeConfig.picture) {
          renderConfig.compName = 'w-uploadImgIncome'
        }
        // 去除空格
        if (trimKeys.includes(item.field)) {
          renderConfig.trim = true
        }
        const customField = {
          ...config,
          renderConfig,
          columnInfo: { ...config }
        }
        // 上传为[]
        // const value = (item.type === fieldTypeConfig.picture || item.type === fieldTypeConfig.enclosure) ? [] : ''
        return {
          show: getIsShow(item.field, permissions, showAll),
          isTxt: getIsTxt(item.field, permissions),
          required: getIsRequired(item.field, permissions),
          customField,
          columnInfo: { ...config },
          value:
            module.subField === 0
              ? unref(formDataField)[item.field]
              : undefined,
          defaultValue:
            module.subField === 0
              ? unref(formDataField)[item.field]
              : unref(formDataList)[item.field],
          ...config,
          fieldCode: item.field
        }
      })
      positionsList.value.push(module)
    }
    originFormData.value = cloneDeep(unref(formDataField))
    visibleShow()
  }
  // 处理显隐规则
  function visibleShow() {
    // 就是根据现有规则去修改子表字段的show的值
    positionsList.value.forEach((item: Recordable) => {
      // 从这个里面去找，{"普通员工": ["联系人"]}
      // visibleList
      // item.affiliationType 这个就是子表的标识
      console.log(visibleList, 'visibleList')
      visibleList.value.forEach((visible: Recordable) => {
        Object.values(visible.rule).forEach((key: any) => {
          if (key.includes(item.affiliationType)) {
            item.visibleEmitter.on(
              `showtable${visible.field}`,
              (show: boolean) => {
                item.show = show
              }
            )
            item.show = false
          }
        })
      })
    })
    console.log(positionsList, 'positionsList')
  }

  // 根据不同的字段确确定精度
  function getPrecisionsByName(item: Recordable) {
    return precisionsObj[item.field]
  }

  // 根据不同的字段确确定单位
  function getUnitByName(item: Recordable) {
    return unitObj[item.field]
  }

  // 是否未只读
  function getIsTxt(id: string, columnPermission: any) {
    // ['READ', 'WRITE', 'REQUIRED']
    if (columnPermission[id]) {
      if (
        columnPermission[id].includes('WRITE') ||
        columnPermission[id].includes('REQUIRED')
      ) {
        return false
      }
    }
    return true
  }

  // 判断是的为必填
  function getIsRequired(id: string, columnPermission: any) {
    // ['READ', 'WRITE', 'REQUIRED']
    if (columnPermission[id]) {
      if (columnPermission[id].includes('REQUIRED')) {
        return true
      }
    }
    return false
  }
  // 是否展示此字段
  function getIsShow(_id: string, _columnPermission: any, _showAll: boolean) {
    return true
  }
  return {
    getPrecisionsByName,
    getUnitByName,
    formatFieldConfig,
    positionsList,
    formDataField,
    originFormData,
    formDataList,
    retailIntoInfoDO,
    productDetails,
    baseExtendDO
  }
}
